import { render, staticRenderFns } from "./file-uploader-dialog.vue?vue&type=template&id=2eb48abc"
import script from "./file-uploader-dialog.vue?vue&type=script&lang=ts"
export * from "./file-uploader-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports